export type WritingPlan = { weekStart: 0 | 1; days: Record<string, number>; goals: Record<string, number> };
export const emptyPlan = (): WritingPlan => ({ weekStart: 1, days: {}, goals: {} });
export function readWritingPlan(key: string): WritingPlan {
  try {
    const value = JSON.parse(localStorage.getItem(key) || 'null');
    if (!value || !value.days || typeof value.days !== 'object') return emptyPlan();
    const goals = Object.fromEntries(Object.entries(value.goals ?? {}).filter(([day, goal]) => /^\d{4}-\d{2}-\d{2}$/.test(day) && typeof goal === 'number' && Number.isInteger(goal) && goal >= 0)) as Record<string, number>;
    return { goals, weekStart: value.weekStart === 0 ? 0 : 1, days: Object.fromEntries(Object.entries(value.days).filter(([day, goal]) => /^\d{4}-\d{2}-\d{2}$/.test(day) && typeof goal === 'number' && Number.isInteger(goal) && goal >= 0)) as Record<string, number> };
  } catch { return emptyPlan(); }
}
export function canPlanDay(days: Record<string, number>, day: string) {
  const date = Date.parse(`${day}T12:00:00Z`);
  return Object.keys(days).every(other => other === day || Math.abs(Date.parse(`${other}T12:00:00Z`) - date) >= 7 * 86400000);
}
